module.exports = __webpack_public_path__ + "static/media/ex30.ab3c2314.mp3";